module.exports = __webpack_public_path__ + "static/media/photo-14.a70d060f.png";